import { Component, Inject, Injector, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-approved-message',
  templateUrl: './dialog-approved-message.component.html',
  styleUrls: ['./dialog-approved-message.component.scss']
})
export class DialogApprovedMessageComponent implements OnInit {
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private dialogRef: MatDialogRef<DialogApprovedMessageComponent>) { }
  showMessage: boolean = true;
  showSuccess: boolean = false;
  ngOnInit(): void {

  }

  cancel() {
    this.dialogRef.close();
    this.showMessage = false;
  }


  submit() {
    this.showMessage = false;
    this.showSuccess = true;
  }

  ok() {
    this.dialogRef.close();
  }
}
